import { render } from "./ConsentModal.vue?vue&type=template&id=7f80ef58&scoped=true"
import script from "./ConsentModal.vue?vue&type=script&lang=js"
export * from "./ConsentModal.vue?vue&type=script&lang=js"

import "./ConsentModal.vue?vue&type=style&index=0&id=7f80ef58&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f80ef58"]])

export default __exports__